// extracted by mini-css-extract-plugin
export default {"dateTime":"Nav_dateTime__m2HkA","time":"Nav_time__AEzH1"};